/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Text
 * 
 * 1 = TextArea
 * 
 * 2 = Dropdown
 * 
 * 3 = Checkbox
 * 
 * 4 = Radio
 * 
 * 5 = Number
 * 
 * 6 = Date
 */
export enum FieldType {
  Text = 0,
  TextArea = 1,
  Dropdown = 2,
  Checkbox = 3,
  Radio = 4,
  Number = 5,
  Date = 6
}
